module.exports = __webpack_public_path__ + "static/img/expand-aside.76d56700.svg";